import { render, staticRenderFns } from "./ResolucionGrid.vue?vue&type=template&id=2de1ebcd"
import script from "./ResolucionGrid.vue?vue&type=script&lang=js"
export * from "./ResolucionGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports